<template>

    <div class="products">
      
        <draggable :clone="cloneProduct" :list="filteredProducts" :options="{handle:'img', chosenClass:'is-chosen-module', ghostClass: 'ghost', dragClass: 'drag', delay:400, sort:false, group:{ name:'modules',  pull:'clone', put:false }}" class="product-list columns is-mobile is-multiline">
            <div class="product column is-half-desktop" @click="handleModuleClick(item)" v-for="(item, index) in filteredProducts" v-bind:key="index"><img class="module top" :src="item.icon"><div class="product-title">{{item.name}}</div></div>
        </draggable>  

    </div>

</template>

<script>

import {mapGetters, mapActions} from 'vuex' 
import draggable from 'vuedraggable'
import Module from './Module'
import { EventBus } from '@/utils/event-bus.js'
import Settings from './Settings'
export default {

  name: 'Products',

  props:['size'],

  data: function(){
    
    return {
        
        filter:"",
        moduleDragOptions : {handle:'.product', chosenClass:'is-chosen-module', ghostClass: 'ghost', dragClass: 'drag', sort:false, group:{ name:'modules',  pull:'clone', put:false }},
        frameDragOptions: {handle:'img', chosenClass:'is-chosen-frame', ghostClass: 'ghost', dragClass: 'drag', sort:false, group:{ name:'frames',  pull:'clone', put:false }}
    }

  },

  computed:{

    ...mapGetters(['configuration','products','getHistory', 'addons', 'frames', 'presets', 'frameType','all_products']),

    frameTypeSync: {
        get() {
            return this.frameType;
        },
        set(value) {
          this.$store.commit('SET_BUILD_MODE', {key:'frame_type', value});
        }
    },

    activeTab(){
        return (this.showSettings)?1:0;
    },

    filteredProducts: function() {

        var vm = this;
        
        if(this.filter === "") {
            return vm.all_products;
        } else {
            return vm.all_products.filter(function(product) {
                return product.tags.includes(vm.filter);
            });
        }
    }

  },

  methods:{

    ...mapActions(['ADD_ITEM', 'ADD_GROUP']),

    handleModuleClick(item){

        var payload = this.cloneProduct(item);

        payload.position = 'end';
         
        switch(item.type){

            case 'frame':

                payload.index = this.configuration.length;
            
                this.ADD_GROUP(payload).then(response => {
                    //EventBus.$emit('item-added');            
                });
                break;
       
            case 'module':
            default:

                this.ADD_ITEM(payload).then(response => {
                    EventBus.$emit('item-added');            
                });
                break;
        }
        
        
    },

    handleFrameClick(item){
        var clone = this.cloneProduct(item);   

    },

    cloneProduct: function (original){
       
        
       return JSON.parse(JSON.stringify(original))
    }
  },

  components:{
      draggable,
      Module
  }

}
</script>

<style>
.products .tabs{
    display:none;
}
</style>

<style scoped>

.products{
    padding:0 1em;
    background:white;
}

.product-list{
   border-bottom:1px solid gray;


}


.navbar{
    padding:10px;
     background: #fafafa;
}

.tabs ul{
    border-bottom:none;
}




.product:hover img{
    transform:scale(1.07);
    opacity:0.8;
}

.product:active img{
    transform:scale(1);
    opacity:1;
}

img{
    max-width: 100%;
    height:auto;
}

@media only screen and (max-width: 1087px) {

    .products{
        display: block;
        overflow:hidden;
        max-width: 100vw;
        padding:0;
    }

    .product-list{
        border:none;
        overflow:auto;
        white-space: nowrap;
         max-width: 100%;
        display:block;
        margin:0;
    }

    .product{
        display:inline-block;
    }

    .product img{
        max-width:80px;
    }

}


/* 
[class^="is-choosen-"] .product-title{
    display: none;
} */



</style>
